module.exports = __webpack_public_path__ + "static/UNB-b2ec5a68b63645372133f6ff3e05335a.woff2";